import type { HttpMock } from '#e2e-utils/mockScenarios';
import { ControllerStatus } from '#models/ControllerStatus.enum';
import type { ControllerDetails } from '#services/cve/ControllerDetails';

export const emailEscalationMocks: HttpMock[] = [
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId/controls/EconomicSanctions$',
    },
    response: {
      status: 200,
      body: {
        controlCode: 'EconomicSanctions',
        statusCode: ControllerStatus.CHECK_REJECTED,
        check: {
          requestorId: 'CVE',
          requestDateTime: '2024-05-21T13:29:56.409Z',
          responseDateTime: '2024-05-21T13:29:56.409Z',
          expirationDateTime: '2999-05-21T13:29:56.409Z',
          controlData: {
            sanctions: [
              {
                companyId: '113',
                sanctionId: '115250479-20230317135606274587',
                sanctionSource: {
                  originCode: 'Manual creation',
                  updateOriginCode: 'Manual creation',
                },
                sanctionTypeCode: 'SP',
                sanctionUpdateDateTime: '2023-03-17',
                sanctionCreationDate: '2023-03-17',
                isContinuatedSanction: true,
                sanctionEffectiveEndDate: '2025-03-17',
                isActive: true,
              },
            ],
            consecutiveSanctionsEndDate: '2025-03-17',
            rejectCode: 'ONGOING_SANCTION',
            escalationContact: 'test@allianz-trade.com',
          },
        },
      } satisfies ControllerDetails,
    },
  },
];
